import { render, staticRenderFns } from "./VIconPrint.vue?vue&type=template&id=8a33f278&"
import script from "./VIconPrint.vue?vue&type=script&lang=ts&"
export * from "./VIconPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports